import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/auth';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, loading } = useAuth();
  const [shouldRedirect, setShouldRedirect] = useState(false);

  useEffect(() => {
    // If no user and not loading, wait a grace period before redirecting
    // This gives time for the session to be restored on external navigations (like Stripe return)
    if (!loading && !user) {
      const timer = setTimeout(() => {
        setShouldRedirect(true);
      }, 150); // 150ms grace period
      return () => clearTimeout(timer);
    } else {
      setShouldRedirect(false);
    }
  }, [loading, user]);

  if (loading) {
    return null;
  }

  if (!user && shouldRedirect) {
    return <Navigate to="/login" replace />;
  }

  if (!user) {
    return null;
  }

  return <>{children}</>;
};
